// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.payment.AccountingUpdatePaymentGroupRequest */
/* istanbul ignore next */
@GandalfModel
export class AccountingUpdatePaymentGroupRequest extends GandalfModelBase {

	@GandalfLabel('Payment date')
	@GandalfValidator({ notNull: { message: 'Payment date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	paymentDate!: Date;

	@GandalfLabel('Payment Group')
	@GandalfValidator({ notNull: { message: 'Payment Group is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	paymentGroupId!: number;

	@GandalfConstantDecorator(constants.PaymentMethodCreditCardType)
	@GandalfLabel('Payment method credit card type')
	@GandalfProperty({ designType: constants.PaymentMethodCreditCardType })
	paymentMethodCreditCardType!: constants.PaymentMethodCreditCardType | null;

	@GandalfConstantDecorator(constants.PaymentMethodType)
	@GandalfLabel('Payment method type')
	@GandalfValidator({ notNull: { message: 'Payment method type is required' } })
	@GandalfProperty({ designType: constants.PaymentMethodType, isRequired: true })
	paymentMethodType!: constants.PaymentMethodType;

	@GandalfLabel('Reference number')
	@GandalfValidator({ sizeString: { message: 'Reference number cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	referenceNumber!: string | null;

}
